var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-8",attrs:{"id":"page_not_found"}},[_vm._v("\n\tSorry but this page could not be found...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }